export function currentTransactionContext(state = [], action) {
  switch (action.type) {
    case "TRANSANCTION_TYPE":
      return action.transactionType
    default:
      return state
  }
}
